import { BaseTextInput } from "../../../components/forms/TextFields";
import { useContext, FC, useState, useEffect, Fragment } from "react";
import { Vacancy } from "../../home/models/Vacancies";
import { InputWrapper } from "../../../components/forms/InputWrapper";
import { SurveyPostObject } from "../../../service/apiHelper";
import { apiHandler } from "../../../service/apiHelper";
import { Store } from "../../../context/store";
import { useLocation } from "react-router";
import { FileUploadField } from "../../../components/forms/FileUploadField";
import ReactDOM from "react-dom";
import { RaceBy } from "@uiball/loaders";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router";
import { Survey } from "../../../components/forms/Survey";
import { CheckIcon } from "@heroicons/react/24/outline";

export interface FieldProps {
  value: string | boolean | Date;
  showError: boolean;
  errorMessage: string;
}

export const ApplyPage: FC<{ vacancy: Vacancy }> = ({ vacancy }) => {
  const location = useLocation();
  const store = useContext(Store);
  const [inputs, setInputs] = useState<SurveyPostObject[]>([]);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [resume, setResume] = useState<Blob>();
  const vacancyId = location.pathname.split("/")[2];
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const headers = {
    "x-api-key": store.apiKey,
  };

  const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append("FirstName", firstName);
    formData.append("LastName", lastName);
    formData.append("EmailAddress", email);
    formData.append("PhoneNumber", phone);
    formData.append("Resume", resume as Blob);

    let surveys = inputs.find(
      (survey) =>
        survey.isRequired === true &&
        (survey.ResponseValue === "" ||
          survey.ResponseValue === null ||
          survey.ResponseValue === "--")
    );
    if (surveys) {
      showFormNotificationError("Please complete all required fields", "");
    } else {
      const allSurveys: Survey[] = [];

      inputs.forEach((survey) => {
        let _survey: SurveyPostObject = {
          SurveyId: survey.SurveyId,
          SurveyLabel: survey.SurveyLabel,
          ResponseText: survey.ResponseText,
          ResponseValue: survey.ResponseValue,
        };

        allSurveys.push(_survey);
      });
      formData.append("SurveyResponses", JSON.stringify(allSurveys));
      setIsLoading(true);
      // console.log("Submitting form data", JSON.stringify(allSurveys));

      //TODO: Uncomment below to enable submission
      submitRequest(formData);
    }
  };

  const showFormNotificationError = (header: string, copy: string) => {
    let timer = setTimeout(function () {
      store.setShowNotification(false);
    }, 4000);

    store.setNotificationStatus(false);
    store.setNotificationHeader(header);
    store.setNotificationCopy!(copy);
    store.setShowNotification(true);
    return () => clearTimeout(timer);
  };
  const submitRequest = async (body: {}) => {
    const api = await apiHandler({
      url: `${store.baseUrl}/${store.code}/jobs/${vacancyId}`,
      method: "POST",
      headers: headers,
      body: body,
    });

    if (api.success) {
      setShowSuccess(true);
    } else {
      setIsLoading(false);
      showFormNotificationError(
        "There was an error submitting your application",
        api.data.message
      );
    }
  };

  const handleChange = (obj: SurveyPostObject) => {
    setInputs(
      inputs.map((survey) => {
        if (survey.SurveyId === obj.SurveyId) {
          return {
            ...survey,
            ResponseValue: obj.ResponseValue,
            ResponseText: obj.ResponseText,
          };
        } else {
          return survey;
        }
      })
    );
  };

  useEffect(() => {
    const _surArray: SurveyPostObject[] = [];
    vacancy.surveys?.forEach((survey) => {
      let _survey: SurveyPostObject = {
        SurveyId: survey.id,
        SurveyLabel: survey.label,
        ResponseText: "",
        ResponseValue: "",
        isRequired: survey.required,
      };

      _surArray.push(_survey);
    });
    setInputs(_surArray);
  }, [vacancy.surveys]);

  return (
    <>
      <div id="apply-section" className="mx-auto mt-14">
        <form
          encType="multipart/form-data"
          onSubmit={onSubmitHandler}
          className="py-8 text-gray-700 border-t "
          id=""
        >
          <h2 className="space-y-6 text-base font-semibold text-gray-900">
            Submit your Application
          </h2>
          <section className="pb-6 space-y-6 border-b">
            <div className="grid gap-6 mt-6 sm:grid-cols-2">
              <BaseTextInput
                label="First Name"
                placeHolder="Enter your first name"
                id="firstName"
                required={true}
                name="firstName"
                handleChange={setFirstName}
              />
              <BaseTextInput
                label="Last Name"
                placeHolder="Enter your last name"
                id="lastName"
                required={true}
                name="lastName"
                handleChange={setLastName}
              />
              <BaseTextInput
                label="Email"
                placeHolder="example@email.com"
                id="email"
                type="email"
                required={true}
                name="emailAddress"
                handleChange={setEmail}
              />
              <BaseTextInput
                label="Phone"
                placeHolder="1234567890"
                id="phone"
                required={true}
                type="tel"
                name="phoneNumber"
                handleChange={setPhone}
              />
            </div>

            <FileUploadField
              label="Resume"
              placeHolder=""
              type="file"
              id="resume"
              required={true}
              name="resume"
              handleChange={setResume}
            />
          </section>
          <section className="py-6 space-y-12 leading-7 text-gray-700">
            {vacancy.surveys?.map((field, index) => (
              <InputWrapper
                handleChange={handleChange}
                inputProps={field}
                key={field.id}
                name={field.id}
              />
            ))}
          </section>

          {!vacancy.isClosed ? (
            <button
              type="submit"
              className="inline-flex items-center px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary-600 hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
            >
              Submit your application
            </button>
          ) : (
            <div className="p-6 text-sm font-semibold text-center rounded-md text-error-600 bg-error-25">
              This job listing is not accepting applications
            </div>
          )}
        </form>

        {ReactDOM.createPortal(
          <Transition.Root show={isLoading} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => {}}>
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 transition-opacity bg-modal" />
              </Transition.Child>

              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <div>
                      {showSuccess ? (
                        <Dialog.Panel className="relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                          <div>
                            <div className="flex items-center justify-center w-12 h-12 mx-auto rounded-full bg-success-100">
                              <CheckIcon
                                className="w-6 h-6 text-success-600"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="mt-3 text-center sm:mt-5">
                              <Dialog.Title
                                as="h3"
                                className="text-base font-semibold leading-6 text-gray-900"
                              >
                                Successful!
                              </Dialog.Title>
                              <div className="mt-2">
                                <p className="text-sm text-gray-500">
                                  Your application was successfully submitted
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="mt-5 sm:mt-6">
                            <button
                              type="button"
                              className="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-primary-600 hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
                              onClick={() => {
                                navigate(0);
                              }}
                            >
                              Ok
                            </button>
                          </div>
                        </Dialog.Panel>
                      ) : (
                        <RaceBy
                          size={120}
                          lineWeight={5}
                          speed={1.4}
                          color="#f9fafb"
                        />
                      )}
                    </div>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>,
          document.getElementById("modal-root")!
        )}
      </div>
    </>
  );
};
